import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import PropertyMultiselectAdvanced from 'components/shared/PropertyMultiselectAdvanced';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import { Form as AntdForm } from 'antd';

import { getPropertiesForMultiselect } from 'components/shared/PropertyMultiselectAdvanced/store/actions';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledColMb8 = styled(Col)`
  margin-bottom: 8px;
`;

const PropertyMultiSelect = ({ properties, values, errors, touched, setFieldValue }) => {
  const getPropertyIdsForUuids = useCallback(
    (propertyUuids) => {
      const propertyIds = properties
        .filter((p) => propertyUuids.map(String).includes(p.attributes.unique_id))
        .map((p) => p.attributes.id);
      return propertyIds;
    },
    [properties]
  );

  // On edit we have an array of property_uuids
  // and have to load the property_ids for multiselect
  useEffect(() => {
    const propertyUuids = values.property_uuids;
    const propertyIds = getPropertyIdsForUuids(propertyUuids);

    setFieldValue('properties', propertyIds);
    setFieldValue('property_uuids', propertyUuids);
  }, [getPropertyIdsForUuids, values.property_uuids, setFieldValue]);

  useEffect(() => {
    if (properties.length === 0) {
      getPropertiesForMultiselect();
    }
  }, [properties.length]);

  // Document Templates use unique ids for properties
  // The property multi select only returns property id as a number
  // Find the unique ids, which we'll use to create the document template
  const getPropertyUuidsForIds = (propertyIds) => {
    const propertyUuids = properties
      .filter((p) => propertyIds.map(String).includes(p.id))
      .map((p) => p.attributes.unique_id);
    return propertyUuids;
  };

  const handleChange = (propertyIds) => {
    const propertyUuids = getPropertyUuidsForIds(propertyIds);

    setFieldValue('properties', propertyIds);
    setFieldValue('property_uuids', propertyUuids);
    // Reset base_document_template_ids when properties change as options
    // may change if selected properties do not have a lease type document template
    setFieldValue('base_document_template_ids', []);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <StyledColMb8 span={24}>
          <StyledTitle>
            {getTranslatedString('landlordPortal.documentTemplate.whichProperties')}
          </StyledTitle>
        </StyledColMb8>
        <Col span={24}>
          <AntdForm layout="vertical">
            <Form.Item label={getTranslatedString('landlordPortal.events.propertiesLabel')}>
              <PropertyMultiselectAdvanced
                name="properties" // this has to be "properites" as we match this in property_filters_for_review.rb#organize_properties
                onChange={handleChange}
                value={values.properties}
                error={touched.property_uuids && errors.property_uuids}
              />
            </Form.Item>
          </AntdForm>
        </Col>
      </Row>
    </Spacer>
  );
};

const mapStateToProps = (store) => ({
  properties: store.landlord.properties.propertyMultiselect.properties,
});

const mapDispatchToProps = {
  getPropertiesForMultiselect,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyMultiSelect);
